import { postData } from '../utils';

export type PostNewReviewRequest = {
  drugTranslitName: string;
  userName: string;
  rating: number;
  comment: string;
};

export type PostNewReviewResponse = {
  status: number;
};

const postNewReview = async (
  requestObj: PostNewReviewRequest
): Promise<PostNewReviewResponse> => {
  const response = await postData(`drug/rate`, requestObj);
  return response;
};

export default postNewReview;
